<template>
  <v-card
    v-if="isDragging"
    :style="{
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      zIndex: 10,
      backgroundColor: 'rgba(174, 101, 10, 0.5)',
    }"
    @dragover.prevent 
    @drop.prevent="handleDrop"
  >
    <v-container
      class="text-overlay"
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        text-align: center;
        color: white;  /* 텍스트 색상 흰색 */
        font-size: 45px;  /* 텍스트 크기 45px */
        font-weight: 900;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
        width: 100%;
      "
    >
      {{ resultNoticeMessage }}
    </v-container>
  </v-card>
  <v-card
    class="card"
    :style="{
      height: isMobile ? 'max-content' : 'imgHeight',
      flexDirection: isMobile ? 'column' : 'column',
      alignItems: 'start',
      backgroundColor: isDragging ? '#AE650A' : 'white',
      width: screenWidth + 'px',
      position: 'relative',  // 부모 요소의 position을 relative로 설정
      zIndex: 1
    }"
    elevation="0"
  >
      <v-card
        v-if="!goToCart"
        :height="imgHeight"
          class="card"
          elevation="3"
          style="
            display: flex;
            flex-direction: column;
            justify-content: start;
            align-items: center;
          "
          :style="{
            width: `calc(${screenWidth.value}px - 2px)`,
            margin: isMobile ? '0 0 0 5px' : '5px 5px 5px 5px',
            backgroundColor: isDragging ? '#9c9c9c' : 'white',
          }"
          >

          <v-container
            class="text-overlay"
            style="
              display: flex;
              flex-direction: column;     /* 세로 정렬 */
              justify-content: center;
              align-items: center;
              height: 100%;
              text-align: center;
              color: black;
              font-size: 45px;
              font-weight: 800;
              width: 100%;
            "
          >
            <div v-if="!isDragging">파일 변환을 위해 PDF를 업로드하세요</div>

            <input
              type="file"
              ref="fileInput"
              style="display: none"
              @change="handleFileUpload"
            />

            <v-btn
              width="330"
              height="80"
              style="
                font-size: 22px;
                font-weight: 600;
                border-radius: 14px;
                margin-top: 30px; /* 간격을 위해 추가 */
              "
              @click="triggerFileInput"
              :style="{
                width: `calc(${screenWidth.value}px - 2px)`,
                backgroundColor: isDragging ? '#7c7c7c' : '#BF7517',
                color: isDragging ? '#6c6c6c' : 'white',
              }"
            >
              여러 PDF 파일 선택
            </v-btn>
          </v-container>


      </v-card>
  </v-card>
</template>


<script>
import { ref, onMounted, onUnmounted } from 'vue';
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import JSZip from 'jszip';
// pdf.worker.js를 직접 경로로 지정
// pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.6.82/pdf.min.mjs';
pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://unpkg.com/pdfjs-dist@2.11.338/build/pdf.worker.min.js';


export default {
  setup() {
    const isHovering = ref(false);
    const backgroundColor = ref('transparent');
    const imgHeight = ref(0);
    const screenWidth = ref(0);
    const isDragging = ref(false);
    const snackbarOn = ref(false);
    const snackbarColor = ref('');
    const sncakbarText = ref('');
    const resultNoticeMessage = ref('');
    const previewDrawer = ref(false);
    const dragOverWindow  = ref(false);
    let dragLeaveTimer = null;
    

    const handleWindowDragEnter = () => {
      dragOverWindow.value = true;
      showDragBanner();
      if (dragLeaveTimer) {
        clearTimeout(dragLeaveTimer);
        dragLeaveTimer = null;
      }
    };

    
    const handleWindowDragLeave = (event) => {
      // 브라우저 전체를 벗어났는지 감지 (약간의 지연으로 안정성 확보)
      if (!event.relatedTarget) {
        dragLeaveTimer = setTimeout(() => {
          dragOverWindow.value = false;
          hideDragBanner();
        }, 100);
      }
    };

    
    const handleWindowBlur = () => {
      // 창이 완전히 포커스를 잃었으면 드래그 중단
      dragOverWindow.value = false;
      hideDragBanner();
    };


  onUnmounted(() => {
    window.removeEventListener('resize', calculateImgHeight);
  });

    const calculateImgHeight = () => {
      imgHeight.value = window.innerHeight - 114;
      screenWidth.value = window.innerWidth - 15;
    };

    // 드래그 배너 표시 함수
    const showDragBanner = () => {
      resultNoticeMessage.value = '아무곳에나 PDF파일을 두세요'
      isDragging.value = true;
    };

    // 드래그 배너 숨기기 함수
    const hideDragBanner = () => {
      resultNoticeMessage.value = ''
      isDragging.value = false;
    };

    // 드래그가 브라우저 영역 밖으로 나갈 때 체크하는 함수
    const handleDragLeave = (event) => {
      if (!event.relatedTarget || !event.relatedTarget.nodeType) {
        hideDragBanner(); // 마우스가 브라우저 밖으로 나갔다면 배너 숨기기
      }
      isDragging.value = true;
    };

    //2024-10-02_저녁 핸들러 수정
    // 드롭 이벤트 핸들러
    const handleDrop = async (event) => {
      resultNoticeMessage.value = '파일을 확인 중입니다';
      // isDragging.value = false;

      const files = event.dataTransfer.files;
      if (files.length > 0) {
        for (let file of files) {
          const fileExtension = file.name.split('.').pop().toLowerCase();
          if (fileExtension === 'pdf') {
            await processPdfFile(file);
          } else {
            isDragging.value = false;
            snackbarOn.value = true;
            snackbarColor.value = 'red';
            sncakbarText.value = `PDF 확장자만 변환 가능합니다: ${file.name}`;
          }
        }
      }
    };

    const processPdfFile = async (file) => {
      try {
        resultNoticeMessage.value = '파일을 분석 중입니다...';

        const reader = new FileReader();
        reader.onload = async (e) => {
          const pdfData = new Uint8Array(e.target.result);
          const loadingTask = pdfjsLib.getDocument({ data: pdfData });

          loadingTask.onProgress = function(progressData) {
            const percentLoaded = Math.floor((progressData.loaded / progressData.total) * 100);
            resultNoticeMessage.value = `로드 중... ${percentLoaded}% 완료`;
          };

          const pdf = await loadingTask.promise;
          const totalPages = pdf.numPages;
          const zip = new JSZip();
          const folderName = file.name.replace('.pdf', '');
          let pagesProcessed = 0;
          const minPercentPerPage = 100 / totalPages;

          for (let pageIndex = 1; pageIndex <= totalPages; pageIndex++) {
            const page = await pdf.getPage(pageIndex);
            const viewport = page.getViewport({ scale: 2.7 });
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            canvas.width = viewport.width;
            canvas.height = viewport.height;

            await page.render({ canvasContext: context, viewport }).promise;

            pagesProcessed++;
            const startPercent = Math.min(100, Math.floor((pagesProcessed - 1) * minPercentPerPage));
            const endPercent = Math.min(100, Math.floor(pagesProcessed * minPercentPerPage));
            await incrementPercent(startPercent, endPercent);

            const jpgDataUrl = canvas.toDataURL('image/jpeg');
            const jpgBlob = await (await fetch(jpgDataUrl)).blob();
            zip.file(`${folderName}/page_${pageIndex}.jpg`, jpgBlob);
          }

          resultNoticeMessage.value = `변환 완료. ZIP 파일을 다운로드 중...`;
          isDragging.value = false;

          const zipBlob = await zip.generateAsync({ type: 'blob' });
          const zipUrl = URL.createObjectURL(zipBlob);
          const a = document.createElement('a');
          a.href = zipUrl;
          a.download = `${folderName}.zip`;
          a.click();
        };

        reader.readAsArrayBuffer(file);
      } catch (error) {
        console.error('PDF 문서 처리 중 오류 발생:', error);
        resultNoticeMessage.value = 'PDF 문서 처리 중 오류가 발생했습니다.';
      }
    };



    // 퍼센트를 자연스럽게 증가시키는 함수
    async function incrementPercent(start, end) {
      return new Promise((resolve) => {
        let currentPercent = start;

        const interval = setInterval(() => {
          if (currentPercent >= end) {
            clearInterval(interval);
            resolve(); // 퍼센트 증가가 완료되면 resolve
          } else {
            currentPercent++;
            resultNoticeMessage.value = `${currentPercent}%`; // 퍼센트를 1씩 증가시켜 표시
          }
        }, 50); // 숫자가 1씩 증가하는 간격 (50ms로 설정)
      });
    }


    const fileInput = ref(null);
    const fileContent = ref('');

    const triggerFileInput = () => {
      fileInput.value.click();
    };

    const handleFileUpload = (event) => {
      const files = event.target.files;
      if (files.length > 0) {
        for (let file of files) {
          if (file && file.name.endsWith('.pdf')) {
            isDragging.value = true;
            processPdfFile(file); // 여기서 processPdfFile만 호출하면 됩니다.
          } else {
            snackbarOn.value = true;
            snackbarColor.value = 'red';
            sncakbarText.value = `PDF 확장자만 변환 가능합니다: ${file?.name || '알 수 없음'}`;
          }
        }
      }

      event.target.value = null;
    };






    // 브라우저 포커스를 잃었을 때 드래그 상태 해제
    const handleBlur = () => {
      hideDragBanner();
    };

    onMounted(() => {
      calculateImgHeight(); // 컴포넌트가 마운트되면 이미지 높이를 계산
      window.addEventListener('resize', calculateImgHeight); // 윈도우 크기가 변경될 때마다 이미지 높이를 다시 계산

      // 브라우저 포커스를 잃었을 때 드래그 해제
      window.addEventListener('blur', handleBlur);
      window.addEventListener('dragenter', handleWindowDragEnter);
      window.addEventListener('dragleave', handleWindowDragLeave);
      window.addEventListener('blur', handleWindowBlur);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', calculateImgHeight);
      window.removeEventListener('blur', handleBlur);
      window.removeEventListener('dragenter', handleWindowDragEnter);
      window.removeEventListener('dragleave', handleWindowDragLeave);
      window.removeEventListener('blur', handleWindowBlur);
    });

    return { 
      isHovering, backgroundColor, imgHeight, isDragging, showDragBanner, hideDragBanner, handleDragLeave, handleDrop, processPdfFile,
      snackbarOn, snackbarColor, sncakbarText, resultNoticeMessage, previewDrawer, screenWidth,
      fileInput, fileContent, triggerFileInput, handleFileUpload,
    };
  }
};
</script>